import { i18n } from "@lingui/core";
import { messages as enMessages } from "../../locales/en-US/messages.mjs";
import { messages as jaMessages } from "../../locales/ja-JP/messages.mjs";
import { messages as koMessages } from "../../locales/ko-KR/messages.mjs";

let isInitialized = false;

/**
 * Initialize i18n by loading all locale messages and activating the default locale.
 * This ensures i18n is ready before any component tries to use it.
 * Safe to call multiple times - will only initialize once.
 */
export function initializeI18n(): void {
  if (isInitialized) {
    return;
  }

  // Synchronously load default locale messages to avoid race conditions
  i18n.load({
    "en-US": enMessages,
    "ko-KR": koMessages,
    "ja-JP": jaMessages,
  });

  // Activate default locale
  i18n.activate("en-US");

  isInitialized = true;
}
